import { render, staticRenderFns } from "./changeFeeAdd.vue?vue&type=template&id=254b4ae7&scoped=true"
import script from "./changeFeeAdd.vue?vue&type=script&lang=js"
export * from "./changeFeeAdd.vue?vue&type=script&lang=js"
import style0 from "./changeFeeAdd.vue?vue&type=style&index=0&id=254b4ae7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b4ae7",
  null
  
)

export default component.exports